import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetAccountTransactionsQuery } from "../../../services/Reports";
import {
  getAccountTransactionsRequest,
  getAccountTransactionsFailure,
  getAccountTransactionsSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);
  const accountState = useAppSelector((state) => state.accountCharts);
  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allAccountTransactions,
    isLoading: accountTransactionsLoading,
    isError: accountTransactionsError,
  } = useGetAccountTransactionsQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.accountTransactionsPageNo,
    pageSize: state.accountTransactionsPageSize,
    fromDate: new Date(state.accountTransactionsFromDate).toLocaleDateString(),
    toDate: new Date(state.accountTransactionsToDate).toLocaleDateString(),
    accountId: accountState.accountId,
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (accountTransactionsLoading) {
      dispatch(getAccountTransactionsRequest());
    }
    if (accountTransactionsError) {
      dispatch(getAccountTransactionsFailure(accountTransactionsError));
    }
    if (allAccountTransactions) {
      dispatch(
        getAccountTransactionsSuccess({
          data: allAccountTransactions.data.accountTransactions[0].data || [],
          totalPages:
            allAccountTransactions.data.accountTransactions[0].metadata[0]
              ?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allAccountTransactions,
    profileData,
    state.accountTransactionsFromDate,
    state.accountTransactionsToDate,
    state.accountTransactionsPageNo,
    state.accountTransactionsPageSize,
  ]);
  return <></>;
};
export default Content;
